import React, { useMemo } from "react";
import { validateStartTimeRanges } from "../../../helpers/modelBuilder/departureTimeConfig";

export default function GranularDepartureRangesEditor({
  ranges = [],
  isEditing = false,
  isSaving = false,
  onAddRange,
  onUpdateRange,
  onRemoveRange,
}) {
  const validation = useMemo(() => validateStartTimeRanges(ranges), [ranges]);
  const totalPct = ranges.reduce(
    (sum, range) => sum + (Number(range?.probabilityWeightPct) || 0),
    0
  );

  return (
    <div className="mb-config-field">
      <label className="mb-config-label">Departure ranges</label>
      <div className="mb-config-rangeTable">
        <div className="mb-config-rangeHeader">Population %</div>
        <div className="mb-config-rangeHeader">Range start</div>
        <div className="mb-config-rangeHeader">Range end</div>
        <div className="mb-config-rangeHeader">Action</div>
        {ranges.map((range, index) => (
          <React.Fragment key={`start-time-range-${index}`}>
            <input
              className="mb-config-input"
              type="number"
              min="0"
              max="100"
              step="0.01"
              value={range?.probabilityWeightPct ?? ""}
              onChange={(event) => onUpdateRange?.(index, "probabilityWeightPct", event.target.value)}
              disabled={isSaving || !isEditing}
              aria-label={`Range ${index + 1} population percentage`}
            />
            <input
              className="mb-config-input"
              type="number"
              min="0"
              step="1"
              value={range?.rangeStart ?? ""}
              onChange={(event) => onUpdateRange?.(index, "rangeStart", event.target.value)}
              disabled={isSaving || !isEditing}
              aria-label={`Range ${index + 1} start in minutes`}
            />
            <input
              className="mb-config-input"
              type="number"
              min="0"
              step="1"
              value={range?.rangeEnd ?? ""}
              onChange={(event) => onUpdateRange?.(index, "rangeEnd", event.target.value)}
              disabled={isSaving || !isEditing}
              aria-label={`Range ${index + 1} end in minutes`}
            />
            <button
              className="mb-btn mb-btnDanger"
              type="button"
              onClick={() => onRemoveRange?.(index)}
              disabled={isSaving || !isEditing}
            >
              Remove
            </button>
          </React.Fragment>
        ))}
      </div>
      {isEditing ? (
        <button className="mb-btn mb-btnSecondary" type="button" onClick={onAddRange} disabled={isSaving}>
          Add range
        </button>
      ) : null}
      <div className={`mb-config-rangeTotal ${validation.valid ? "isValid" : "isInvalid"}`}>
        Total: {totalPct}% / 100%
      </div>
      {!validation.valid ? <div className="mb-config-msg isError">{validation.error}</div> : null}
      {validation.valid ? (
        <div className="mb-config-help">
          API departure bounds will be derived as {validation.minDepartureTime}–{validation.maxDepartureTime} minutes.
        </div>
      ) : null}
    </div>
  );
}
